export const emptyFunction = (_data: unknown) => {
  // This is intentional
};
